import { c as _c } from "react/compiler-runtime";
import React, { type ReactNode } from 'react';
import { useSignUpQ1Variant } from '../_hooks/use-sign-up-q1-variant';
const AuthBranch = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    variant
  } = useSignUpQ1Variant();
  let controlChild;
  let experimentChild;
  if ($[0] !== children) {
    controlChild = null;
    experimentChild = null;
    React.Children.forEach(children, child => {
      if (!React.isValidElement(child)) {
        return;
      }
      if (child.type === AuthBranch.Control) {
        controlChild = child;
      } else {
        if (child.type === AuthBranch.Experiment) {
          experimentChild = child;
        }
      }
    });
    $[0] = children;
    $[1] = controlChild;
    $[2] = experimentChild;
  } else {
    controlChild = $[1];
    experimentChild = $[2];
  }
  if (variant === "experiment" && experimentChild) {
    return experimentChild;
  }
  return controlChild;
};
const AuthBranchControl = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AuthBranchExperiment = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
AuthBranch.Control = AuthBranchControl;
AuthBranch.Experiment = AuthBranchExperiment;
export { AuthBranch };